import { render, staticRenderFns } from "./dataCentreindextest.vue?vue&type=template&id=7fcf76ac&scoped=true&"
import script from "./dataCentreindextest.vue?vue&type=script&lang=js&"
export * from "./dataCentreindextest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fcf76ac",
  null
  
)

export default component.exports